import { POST_FORM } from '@/api';

const URL = '/cart/update';

export default async ({ entryNumber, quantity, config, successCB, failCB }) => {
  try {
    const { data } = await POST_FORM(
      `${URL}`,
      { entryNumber, quantity },
      config,
    );
    return (typeof successCB === 'function' && successCB(data)) || data;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
